import { createReducer } from '@reduxjs/toolkit';

import { resetCoOrdersFilter, setCoOrdersFilter } from '../../../actions/coilovers/orders/coOrdersFilter';
import DEFAULT_PAGINATION_SIZE from '../../../constants/general';

const initialState = {
  page: 1,
  size: DEFAULT_PAGINATION_SIZE,
  order: undefined,
  query: undefined,
  orderStatus: undefined,
  orderAssemblyType: undefined,
  orderAssemblyStyle: undefined,
  fromId: undefined,
  toId: undefined,
  marketplaceDateFrom: undefined,
  marketplaceDateTo: undefined,
  assembledDateTo: undefined,
  assembledDateFrom: undefined,
  doneByUser: undefined,
};

const coOrdersFilterReducer = createReducer(initialState, {
  [setCoOrdersFilter]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [resetCoOrdersFilter]: () => initialState
});

export default coOrdersFilterReducer;
